import HttpStatusCode, { isSuccessStatusCode } from '../helpers/HttpStatusCode';
import { LanguageCode } from 'localization/LocalizationData';
import { QuestionnaireInfo, QuestionnairePacket } from 'models/Questionnaire';
import QuestionnaireResource from 'models/QuestionnaireResource';
import { QuestionnaireFromResource } from 'Utilities/ResourceConverter';

const host = '';

export const QuestionnaireService = {
	getList: async function (langIso?: LanguageCode) {
		let url = `${host}/api/questionnaire`;
		if (langIso) {
			url += `?culture=${langIso}`;
		}

		const init = {
			method: 'GET'
		}
		try {
			const response = await fetch(url, init);
			const statusCode = response.status as HttpStatusCode;
			if (!isSuccessStatusCode(statusCode)) {
				Promise.reject("Failed to fetch questionnaire data");
				return [];
			}
			else {
				const list = await response.json().then(json => json as QuestionnaireInfo[]);
				return list;
			}
		}
		catch (reason) {
			return Promise.reject(reason);
		}
	},
	get: async function (id: string, langIso?: LanguageCode) {
		let url = `${host}/api/questionnaire/${id}`;
		if (langIso) {
			url += `?culture=${langIso}`;
		}

		const init = {
			method: 'GET'
		}
		try {
			const response = await fetch(url, init);
			const statusCode = response.status as HttpStatusCode;
			if (!isSuccessStatusCode(statusCode)) {
				return Promise.reject("ei onnistuttu hakemaan");
			}
			else {
				const questionnaireResource = await response.json().then(json => json as QuestionnaireResource);
				return QuestionnaireFromResource(questionnaireResource);
			}
		}
		catch (reason) {
			return Promise.reject(reason);
		}
	},
	start: async function (id: string, langIso?: LanguageCode) {
		let url = `${host}/api/questionnaire/${id}`;
		if (langIso) {
			url += `?culture=${langIso}`;
		}
		const init = {
			method: 'POST'
		}
		try {
			const response = await fetch(url, init);
			const statusCode = response.status as HttpStatusCode;
			if (!isSuccessStatusCode(statusCode)) {
				return Promise.reject("Failed to fetch questionnaire data");
			}
			else {
				const questionnaire = await response.json().then(json => json as QuestionnairePacket);
				return questionnaire;

			}
		}
		catch (reason) {
			return Promise.reject(reason);
		}
	},
	post: async function (token: string, results: any) {

	}

}

export default QuestionnaireService;
